import { useModal } from 'common/hooks/useModalGrapes';
import { BetaFeatureNotice } from 'src/core/common/components/BetaFeatureNotice';
import FEATURES from 'src/core/constants/features';
import { BudgetPeriodTags } from 'src/core/modules/budgets/components/BudgetPeriodTags';

import { CreateBudgetaryExerciseModalContainer } from '../../../../containers/CreateBudgetaryExerciseModalContainer';
import { useRedirectToBudgetaryExercise } from '../../../../containers/hooks/useRedirectToBudgetaryExercise';
import {
  getBudgetaryExercisePeriod,
  type BudgetaryExercise,
} from '../../../../models/budgetaryExercise';
import { BudgetaryExerciseDropdown } from '../BudgetaryExerciseDropdown';

export const HeaderContent = ({
  budgetaryExercise,
  isBudgetaryExerciseSelectable = true,
}: {
  budgetaryExercise: BudgetaryExercise;
  isBudgetaryExerciseSelectable?: boolean;
}) => {
  const redirectToBudgetaryExercise = useRedirectToBudgetaryExercise();
  const [
    budgetaryExerciseCreationModal,
    showBudgetaryExerciseCreationModal,
    hideBudgetaryExerciseCreationModal,
  ] = useModal(({ isOpen }: { isOpen: boolean }) => {
    if (!isOpen) {
      return <></>;
    }
    return (
      <CreateBudgetaryExerciseModalContainer
        onHide={() => {
          hideBudgetaryExerciseCreationModal();
        }}
      />
    );
  });

  return (
    <div className="flex items-center gap-16">
      <BetaFeatureNotice
        featureName={FEATURES.BUDGETS_BY_DIMENSIONS}
        feedbackTags={['budgets-v2']}
        showOnlyFeedbackModal
      />
      <BudgetaryExerciseDropdown
        currentBudgetaryExercise={budgetaryExercise}
        isDisabled={!isBudgetaryExerciseSelectable}
        onBudgetaryExerciseSelect={(budgetaryExerciseId) => {
          redirectToBudgetaryExercise(budgetaryExerciseId);
        }}
        onCreateBudgetaryExercise={() => {
          showBudgetaryExerciseCreationModal();
        }}
      />
      <BudgetPeriodTags
        period={getBudgetaryExercisePeriod(budgetaryExercise)}
      />
      {budgetaryExerciseCreationModal}
    </div>
  );
};
